import { render, staticRenderFns } from "./AddModel.vue?vue&type=template&id=c2a109be&scoped=true"
import script from "./AddModel.vue?vue&type=script&lang=js"
export * from "./AddModel.vue?vue&type=script&lang=js"
import style0 from "./AddModel.vue?vue&type=style&index=0&id=c2a109be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a109be",
  null
  
)

export default component.exports